module.exports = __webpack_public_path__ + "public/img/zx4.9aaa0762.png";